import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=a9003856&scoped=true&"
import script from "./Schools.vue?vue&type=script&lang=js&"
export * from "./Schools.vue?vue&type=script&lang=js&"
import style0 from "./Schools.vue?vue&type=style&index=0&id=a9003856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9003856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VContainer,VDataTable,VIcon,VTooltip})
